import initVivialConnectAPI from "@moosetalk-frontend/global/vivialconnect-js-api";
import config from "config";

const VivialConnectAPI = initVivialConnectAPI(config);

export default VivialConnectAPI;
